interface openModalDetails {
    id: number
    opener?: HTMLElement
}

interface speakerData {
    ID: number
    name: string
    position: string
    content: string
    photo: string
}

declare const speakersData: speakerData[]

export class Modal {
    modal: HTMLDialogElement;
    lastOpener: HTMLElement | null = null;

    constructor(selector: string) {
        this.modal = document.querySelector(selector)
        if (!this.modal || this.modal.nodeName !== 'DIALOG') return;

        window.addEventListener("open-modal", (ev: CustomEvent<openModalDetails>) => this.openModal(ev.detail.id, ev.detail.opener))

        this.modal.addEventListener("close", () => {
            document.body.classList.remove('u-hiddenOverflow')
            this.lastOpener?.focus()
            this.lastOpener = null
        })
        this.modal.addEventListener("click", (ev) => (ev.target === this.modal) && this.modal.close())

        this.modal.querySelector('[data-modal-closer]')?.addEventListener("click", (ev) => {
            ev.preventDefault()
            this.modal.close()
        })
    }

    openModal(id: number, opener?: HTMLElement) {
        const data: speakerData = speakersData?.find((speaker: speakerData) => speaker.ID === id)
        if (!data) return;

        this.modal.querySelector('[data-name]').innerHTML = data.name;
        this.modal.querySelector('[data-position]').innerHTML = data.position;
        this.modal.querySelector('[data-quote]').innerHTML = data.content;
        this.modal.querySelector('[data-photo]').innerHTML = data.photo;

        this.lastOpener = opener ?? (document.activeElement as HTMLElement) ?? null
        document.body.classList.add('u-hiddenOverflow')
        this.modal.showModal()
    }
}

export class ModalOpener {
    el: HTMLElement;

    constructor(el: HTMLElement) {
        if (!el) return;
        this.el = el

        this.el.addEventListener("click", () => this.openModal())
    }

    openModal() {
        const targetModal = (this.el?.closest('[data-id]') as HTMLElement)?.dataset.id
        targetModal && this.el.dispatchEvent(new CustomEvent<openModalDetails>("open-modal", {
            bubbles: true,
            detail: { id: parseInt(targetModal), opener: this.el }
        }))
    }
}